import ReactMarquee from "react-fast-marquee";

export default function Marquee({ items = [], testid = "marquee" }) {
  return (
    <div
      data-testid={testid}
      className="border-y border-white/10 bg-black py-8 md:py-10 overflow-hidden"
    >
      <ReactMarquee gradient={false} speed={38} pauseOnHover>
        {items.map((it, i) => (
          <span
            key={i}
            className="font-serif-display italic text-white/80 text-4xl md:text-6xl lg:text-7xl mx-10 flex items-center gap-10"
          >
            {it}
            <span className="inline-block w-2 h-2 rotate-45 bg-[color:var(--dk-gold)]" />
          </span>
        ))}
      </ReactMarquee>
    </div>
  );
}
